var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import GenericTabs from "@frameworks/shared-library/components/GenericTabs";
import { EClientTabs, clientTabs, partnerTabs } from "./constants";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import clientDi from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import { getQueryParameterName, } from "@frameworks/salesjourney/utils/genericMethods";
import SalesToasts from "@frameworks/shared-library/components/Toasts";
import { ELocalStorageKeys } from "@domains/salesFeatures/Common/entities/ELocalStorageKeys";
var ClientBody = function () {
    var navigate = useNavigate();
    var routchange = function (selectedtab) {
        // window.scrollTo(0, 0);
        navigate("/clientdetails/".concat(selectedtab), { replace: true });
    };
    var uccCode = getQueryParameterName("uccCode");
    var _a = __read(React.useState(), 2), selctPart = _a[0], setSelectPart = _a[1];
    var _b = __read(React.useState(false), 2), searchToast = _b[0], setSearchToast = _b[1];
    var _c = __read(React.useState(false), 2), searchToastError = _c[0], setSearchToastError = _c[1];
    var _d = __read(React.useState(), 2), searchToastMsg = _d[0], setSearchToastMsg = _d[1];
    var tabsName = useParams();
    var _e = __read(React.useState(""), 2), selectedtabName = _e[0], setSelectedTabName = _e[1];
    var loginData = useSelector(function (state) { return state.Login.LoginReducer.reducersData.loginData; });
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var selectedPartner = useSelector(function (state) {
        return state.Partners.partnerSummary.reducersData.selectedPartner;
    });
    React.useEffect(function () {
        var partnerCategory = localStorage.getItem(ELocalStorageKeys.PartnerCategory);
        if (!!partnerCategory &&
            (partnerCategory === null || partnerCategory === void 0 ? void 0 : partnerCategory.length) > 0 &&
            partnerCategory === "BP") {
            var reportTabIndex = clientTabs.findIndex(function (record) {
                record.eventKey === EClientTabs.REPORT;
            });
            clientTabs.splice(reportTabIndex, 1);
        }
    }, []);
    React.useEffect(function () {
        if (!!uccCode && (uccCode === null || uccCode === void 0 ? void 0 : uccCode.length) > 0) {
            setSearchToast(false);
            setSearchToastError(false);
            getClientSearchDataList(window.atob(uccCode));
        }
    }, [uccCode]);
    React.useEffect(function () {
        if (!!selectedPartner && selectedPartner.isPartner) {
            setSelectedTabName(partnerTabs[0].eventKey);
        }
        else if (!!selectedAcount &&
            (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.isPartner) !== null &&
            (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.isPartner) !== undefined &&
            (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.isPartner)) {
            setSelectedTabName(partnerTabs[0].eventKey);
        }
        else if (tabsName && (tabsName === null || tabsName === void 0 ? void 0 : tabsName.clienttabname))
            setSelectedTabName(tabsName === null || tabsName === void 0 ? void 0 : tabsName.clienttabname);
    }, [tabsName === null || tabsName === void 0 ? void 0 : tabsName.clienttabname, loginData, selectedAcount, selectedPartner]);
    var getClientSearchDataList = function (searchText) {
        var url = "";
        if (!!searchText) {
            clientDi.clients.clearSelectedClientData();
            localStorage.setItem("client360SelectedClient", "");
            clientDi.partnerOverview.clearALLStoreData();
            clientDi.clients
                .getClientSearchList({ searchText: searchText })
                .then(function (resp) {
                var _a;
                if (resp && (resp === null || resp === void 0 ? void 0 : resp.length) > 0) {
                    if ((_a = resp[0]) === null || _a === void 0 ? void 0 : _a.isPartner) {
                        var searchActionPayload = {
                            AcCode: resp[0].accountCode,
                            page: 1,
                            pageSize: 100,
                        };
                        clientDi.clients.clearSelectedClientData();
                        clientDi.partnerOverview.getPartnerSearchAction(searchActionPayload, resp[0]);
                    }
                    else {
                        clientDi.partnerOverview.clearALLStoreData();
                        clientDi.clients.setSelectedClientOnSearchClick(resp[0]);
                    }
                    // url =
                    //   config.applicationFolder +
                    //   `/clientdetails/overview?link=${
                    //     resp[0].isPartner ? "profile" : "overview"
                    //   }`;
                }
                else {
                    if ((resp === null || resp === void 0 ? void 0 : resp.length) === 0) {
                        setSearchToastError(true);
                        setSearchToast(true);
                        setSearchToastMsg("No Data Found");
                    }
                    url = "";
                }
            })
                .catch(function (err) {
                setSearchToastError(true);
                setSearchToastMsg("Something went wrong.Please try after some time.");
                setSearchToast(true);
                url = "";
            });
        }
        return url;
    };
    var redirectToHomeDashboard = function () {
        navigate("/dashboard", { replace: true });
    };
    return (React.createElement(GridContainer, { parentClass: " mw-none m-0" },
        React.createElement(GenericTabs, { externalClassName: "common-tab-color ".concat((selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.isPartner) ||
                ((selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.isPartner) !== null &&
                    (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.isPartner) !== undefined &&
                    selectedAcount.isPartner)
                ? "partner-tabs"
                : "partner-tabs"
            // : "client-tabs"
            ), defaultActiveKey: selectedtabName
                ? selectedtabName
                : (selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.isPartner) ||
                    ((selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.isPartner) !== null &&
                        (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.isPartner) !== undefined &&
                        selectedAcount.isPartner)
                    ? partnerTabs[0].eventKey
                    : clientTabs[0].eventKey, tabsArray: (selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.isPartner) ||
                ((selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.isPartner) !== null &&
                    (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.isPartner) !== undefined &&
                    selectedAcount.isPartner)
                ? partnerTabs
                : clientTabs, callBackFunction: function (key) {
                routchange(key);
            } }),
        searchToast && (React.createElement(SalesToasts, { show: searchToast, setShow: function (result) {
                setSearchToast(result);
                redirectToHomeDashboard();
            }, position: "middle-center", message: React.createElement("span", { dangerouslySetInnerHTML: { __html: searchToastMsg } }), isError: searchToastError, parentClass: "lead-create-toast assign-lead" }))));
};
export default ClientBody;
